module.exports = __webpack_public_path__ + "static/media/azo-logo.3077f20a.svg";